var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.selectData,"highlight-current":true,"default-expand-all":true,"expand-on-click-node":false,"node-key":"id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }